"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Price = _interopRequireDefault(require("../Price"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Button = _interopRequireDefault(require("../Button"));
var _Text = _interopRequireDefault(require("../Text"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _utilities = require("../../utilities");
var _constant = require("../JourneyPriceCTA/constant");
var _constant2 = require("./constant");
var _BundlePriceCTA = _interopRequireDefault(require("./BundlePriceCTA.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var BundlePriceCTAWrapper = _styledComponents.default.div.withConfig({
  displayName: "BundlePriceCTA__BundlePriceCTAWrapper",
  componentId: "sc-g9sukg-0"
})(["background:", ";padding:", ";display:flex;align-items:center;justify-content:space-between;border-top:1px solid ", ";cursor:", ";pointer-events:", ";opacity:", ";&:last-child{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}"], function (_ref) {
  var theme = _ref.theme,
    isSelected = _ref.isSelected;
  return isSelected ? theme.backgroundColor.greenLight : theme.backgroundColor.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.XSmall);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyLight;
}, function (_ref4) {
  var isAvailable = _ref4.isAvailable,
    disableSelect = _ref4.disableSelect;
  return isAvailable && !disableSelect ? 'pointer' : 'default';
}, function (_ref5) {
  var isAvailable = _ref5.isAvailable;
  return isAvailable ? 'auto' : 'none';
}, function (_ref6) {
  var isAvailable = _ref6.isAvailable;
  return isAvailable ? '1' : '0.5';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.tiny;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.tiny;
});
var JourneyWrapper = _styledComponents.default.div.withConfig({
  displayName: "BundlePriceCTA__JourneyWrapper",
  componentId: "sc-g9sukg-1"
})(["display:flex;flex-direction:column;"]);
var PriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "BundlePriceCTA__PriceWrapper",
  componentId: "sc-g9sukg-2"
})(["display:flex;flex-direction:column;justify-content:flex-end;& > p{display:flex;justify-content:", ";margin-right:32px;}"], function (_ref9) {
  var isCTAV2 = _ref9.isCTAV2;
  return isCTAV2 ? 'flex-start' : 'flex-end';
});
var PriceIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "BundlePriceCTA__PriceIconWrapper",
  componentId: "sc-g9sukg-3"
})(["display:flex;align-items:center;"]);
var NotAvailableWrapper = _styledComponents.default.div.withConfig({
  displayName: "BundlePriceCTA__NotAvailableWrapper",
  componentId: "sc-g9sukg-4"
})(["display:flex;align-items:center;font-size:", ";font-weight:", ";min-height:46px;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize.small;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeight.medium;
});
var IncludedWrapper = _styledComponents.default.div.withConfig({
  displayName: "BundlePriceCTA__IncludedWrapper",
  componentId: "sc-g9sukg-5"
})(["line-height:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeight.titleSmall;
});
var UpgradedWrapper = _styledComponents.default.div.withConfig({
  displayName: "BundlePriceCTA__UpgradedWrapper",
  componentId: "sc-g9sukg-6"
})(["display:flex;justify-content:center;flex-direction:column;> p{line-height:23px;}"]);
var BundlePriceCTA = function BundlePriceCTA(props) {
  var _selected$journeyType, _selected$journeyType2, _selected$journeyType3;
  var accessible = props.accessible,
    theme = props.theme,
    customProperties = props.customProperties,
    data = props.data,
    locale = props.locale,
    type = props.type,
    selected = props.selected,
    handleSelect = props.handleSelect,
    translation = props.translation,
    currency = props.currency,
    isDowngradable = props.isDowngradable,
    disableSelect = props.disableSelect,
    shouldHideIfUnselected = props.shouldHideIfUnselected,
    ctaVersion = props.ctaVersion,
    isEconomy = props.isEconomy,
    disableButton = props.disableButton,
    isLoading = props.isLoading;
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var journeyType = _constant2.JOURNEY_TYPE[type];
  var isSelected = ((_selected$journeyType = selected[journeyType]) === null || _selected$journeyType === void 0 ? void 0 : _selected$journeyType.type) === (data === null || data === void 0 ? void 0 : data.type) && (((_selected$journeyType2 = selected[journeyType]) === null || _selected$journeyType2 === void 0 ? void 0 : _selected$journeyType2.bundleCode) === (data === null || data === void 0 ? void 0 : data.bundleCode) || ((_selected$journeyType3 = selected[journeyType]) === null || _selected$journeyType3 === void 0 ? void 0 : _selected$journeyType3.bundleId) === (data === null || data === void 0 ? void 0 : data.bundleId));
  var selectedIcon = disableSelect ? _constant2.ICON.DisableCheckIcon : _constant2.ICON.CheckCircleIcon;
  if (shouldHideIfUnselected && !isSelected) return null;
  var getCurrency = function getCurrency() {
    var _data$price;
    return data === null || data === void 0 || (_data$price = data.price) === null || _data$price === void 0 || (_data$price = _data$price.currency) === null || _data$price === void 0 ? void 0 : _data$price.toUpperCase();
  };
  var getPrice = function getPrice() {
    var _data$price2;
    return data === null || data === void 0 || (_data$price2 = data.price) === null || _data$price2 === void 0 ? void 0 : _data$price2.price;
  };
  var getGuestCount = function getGuestCount() {
    return data === null || data === void 0 ? void 0 : data.guest;
  };
  var getDepartStation = function getDepartStation() {
    var _data$designator;
    return data === null || data === void 0 || (_data$designator = data.designator) === null || _data$designator === void 0 ? void 0 : _data$designator.departureStation;
  };
  var getReturnStation = function getReturnStation() {
    var _data$designator2;
    return data === null || data === void 0 || (_data$designator2 = data.designator) === null || _data$designator2 === void 0 ? void 0 : _data$designator2.arrivalStation;
  };
  var getRenderStations = function getRenderStations() {
    return "".concat(getDepartStation(), "-").concat(getReturnStation());
  };
  var getIsAvailable = function getIsAvailable() {
    return data === null || data === void 0 ? void 0 : data.isAvailable;
  };
  var getIsIncluded = function getIsIncluded() {
    return data === null || data === void 0 ? void 0 : data.isIncluded;
  };
  var getIsUpgraded = function getIsUpgraded() {
    return data === null || data === void 0 ? void 0 : data.upgradedTo;
  };
  var handleSelectedBundle = function handleSelectedBundle() {
    if (!getIsAvailable()) {
      return;
    }
    if (handleSelect) {
      // If the `ctaVersion` is version 2, return selected as data object key instead of
      if (ctaVersion === _constant2.CTA_VERSION.V2) {
        handleSelect({
          data: !isSelected ? data : {}
        });
      } else {
        handleSelect(_objectSpread(_objectSpread({}, selected), {}, (0, _defineProperty2.default)({}, journeyType, !isSelected ? data : {})));
      }
    }
  };
  var getDefaultVersion = function getDefaultVersion() {
    var _language$guest;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(JourneyWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant2.STYLE_CONFIG.default,
      color: _constant2.STYLE_CONFIG.secondary
    }, getRenderStations()), /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant2.STYLE_CONFIG.small,
      color: _constant2.STYLE_CONFIG.greyDark
    }, language[type])), /*#__PURE__*/_react.default.createElement(PriceWrapper, null, isDowngradable && !getIsUpgraded() && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PriceIconWrapper, null, !getIsIncluded() ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Price.default, {
      allowLocaleFormat: true,
      locale: locale,
      accessible: accessible,
      amount: getPrice(),
      color: _constant2.STYLE_CONFIG.neutral,
      currency: currency || getCurrency(),
      theme: theme,
      customFontSize: _constant2.STYLE_CONFIG.titleSmall,
      customCurrencySize: _constant2.STYLE_CONFIG.titleSmall,
      priceTemplate: _constant2.PRICE_CONFIG.priceTemplate,
      customProperties: {
        customCurrencyColor: _constant2.STYLE_CONFIG.greyDark
      },
      defaultIDRLocale: false
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: isSelected ? _constant2.STYLE_CONFIG.green : _constant2.STYLE_CONFIG.greyDark,
      fontsize: _constant2.STYLE_CONFIG.titleNormal,
      icon: isSelected ? selectedIcon : _constant2.ICON.AddCircleIcon,
      theme: _constant.THEMES.MOVE
    })) : /*#__PURE__*/_react.default.createElement(IncludedWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, null, language === null || language === void 0 ? void 0 : language.included))), /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant2.STYLE_CONFIG.small,
      color: _constant2.STYLE_CONFIG.greyDark
    }, language === null || language === void 0 || (_language$guest = language.guest) === null || _language$guest === void 0 ? void 0 : _language$guest.replace('{0}', getGuestCount())), ' '), getIsUpgraded() && /*#__PURE__*/_react.default.createElement(UpgradedWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "block",
      textAlign: "right"
    }, language === null || language === void 0 ? void 0 : language.upgraded), /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "block",
      textAlign: "right"
    }, getIsUpgraded())), !isDowngradable && /*#__PURE__*/_react.default.createElement(NotAvailableWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, null, language === null || language === void 0 ? void 0 : language.notAvailable))));
  };
  var getButtonContent = function getButtonContent() {
    if (isLoading) {
      return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        animationDuration: "1s",
        color: "primary",
        height: "16px",
        show: true,
        strokeWidth: "3",
        theme: theme,
        width: "18px"
      });
    }
    return isEconomy ? language.continue : language.select;
  };
  var getVersion2 = function getVersion2() {
    var _language$guest2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PriceWrapper, {
      isCTAV2: true
    }, isDowngradable && !getIsUpgraded() && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PriceIconWrapper, null, !getIsIncluded() ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Price.default, (0, _extends2.default)({
      allowLocaleFormat: true,
      locale: locale,
      accessible: accessible,
      amount: getPrice(),
      color: _constant2.STYLE_CONFIG.neutral,
      currency: currency || getCurrency(),
      theme: theme,
      customFontSize: _constant2.STYLE_CONFIG.titleSmall,
      customCurrencySize: _constant2.STYLE_CONFIG.titleSmall,
      priceTemplate: _constant2.PRICE_CONFIG.priceTemplate,
      customProperties: {
        customCurrencyColor: _constant2.STYLE_CONFIG.greyDark
      },
      defaultIDRLocale: false
    }, !isEconomy && {
      pricePrefix: _constant2.PRICE_CONFIG.pricePrefix
    }, isEconomy && {
      decimalType: _utilities.DECIMAL_TYPE.CEIL
    }))) : /*#__PURE__*/_react.default.createElement(IncludedWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, null, language === null || language === void 0 ? void 0 : language.included))), /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _constant2.STYLE_CONFIG.small,
      color: _constant2.STYLE_CONFIG.greyDark
    }, language === null || language === void 0 || (_language$guest2 = language.guest) === null || _language$guest2 === void 0 ? void 0 : _language$guest2.replace('{0}', getGuestCount())), ' '), getIsUpgraded() && /*#__PURE__*/_react.default.createElement(UpgradedWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "block",
      textAlign: "right"
    }, language === null || language === void 0 ? void 0 : language.upgraded), /*#__PURE__*/_react.default.createElement(_Text.default, {
      display: "block",
      textAlign: "right"
    }, getIsUpgraded())), !isDowngradable && /*#__PURE__*/_react.default.createElement(NotAvailableWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, null, language === null || language === void 0 ? void 0 : language.notAvailable))), /*#__PURE__*/_react.default.createElement(JourneyWrapper, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      backgroundColor: isEconomy ? 'default' : 'primary',
      color: "secondary",
      boxShadow: false,
      buttonType: "button",
      hoverBackgroundColor: isEconomy ? 'default' : 'primary',
      hoverColor: "secondary",
      border: "secondary",
      size: "small",
      paddingLeft: "16px",
      paddingRight: "16px",
      theme: theme,
      handleClick: handleSelectedBundle,
      disabled: disableButton
    }, getButtonContent())));
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(BundlePriceCTAWrapper, (0, _extends2.default)({
      isSelected: ctaVersion === _constant2.CTA_VERSION.V1 && isSelected
    }, !disableSelect && {
      onClick: ctaVersion === _constant2.CTA_VERSION.V1 && handleSelectedBundle
    }, customProperties, {
      type: type,
      isAvailable: isDowngradable && getIsAvailable(),
      disableSelect: disableSelect
    }), ctaVersion === _constant2.CTA_VERSION.V2 ? getVersion2() : getDefaultVersion());
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
BundlePriceCTA.propTypes = _BundlePriceCTA.default.PropTypes;
BundlePriceCTA.defaultProps = _BundlePriceCTA.default.DefaultProps;
var _default = BundlePriceCTA;
exports.default = _default;